import LazyLoad from 'vanilla-lazyload';

const lazyLoadInstance = new LazyLoad({
  elements_selector: 'img[data-lazy-src],.pre-lazyload',
  data_src: 'lazy-src',
  data_srcset: 'lazy-srcset',
  data_sizes: 'lazy-sizes',
  skip_invisible: false,
  class_loading: 'lazyloading',
  class_loaded: 'lazyloaded',
});
const observeLazyImages = () => {
  if (!document.body || !window.MutationObserver) return;

  const selector = 'img[data-lazy-src], .pre-lazyload';
  let updateFrame = null;
  const observer = new MutationObserver((mutations) => {
    const hasLazyContent = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          ((typeof node.matches === 'function' && node.matches(selector)) ||
            node.querySelector(selector))
      )
    );

    if (hasLazyContent && updateFrame === null) {
      updateFrame = window.requestAnimationFrame(() => {
        updateFrame = null;
        lazyLoadInstance.update();
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeLazyImages, {
    once: true,
  });
} else {
  observeLazyImages();
}
